import { combineReducers } from "redux";
import {
  CHANGE_USER_STATUS_REQUEST,
  FETCH_USER_BOOKINGS_REQUEST,
  FETCH_USER_COMMENTS_REQUEST,
  FETCH_USER_FAVORITES_REQUEST,
  FETCH_USER_RATINGS_REQUEST,
  FETCH_USER_REQUEST,
  UPDATE_USER_REQUEST,
  FETCH_USER_WALLET_LIST_REQUEST,
  FETCH_USER_WALLET_LOG_REQUEST,
} from "./constants";
import { UPDATE_CANCEL_BOOKING_REQUEST, UPDATE_CHECKED_BOOKING_REQUEST } from "../bookings/constants";
import { Action, UserBookingState } from "./types";
import { Action as BookingAction } from "../bookings/types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Favorite, Rating, UserComment, UserDetail } from "../types";

function item(state: Partial<UserDetail> = {}, action: Action): Partial<UserDetail> {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_REQUEST):
      return action.payload;
    case getSuccessActionType(CHANGE_USER_STATUS_REQUEST):
      return action.payload;
    case getSuccessActionType(UPDATE_USER_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function bookings(state: UserBookingState[] = [], action: Action | BookingAction): UserBookingState[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_BOOKINGS_REQUEST):
      return action.payload;

    case UPDATE_CANCEL_BOOKING_REQUEST:
    case UPDATE_CHECKED_BOOKING_REQUEST:
      return state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: true,
            }
          : booking
      );

    case getSuccessActionType(UPDATE_CANCEL_BOOKING_REQUEST):
    case getSuccessActionType(UPDATE_CHECKED_BOOKING_REQUEST):
      return state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : booking
      );

    case getFailureActionType(UPDATE_CANCEL_BOOKING_REQUEST):
    case getFailureActionType(UPDATE_CHECKED_BOOKING_REQUEST):
      return state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: false,
            }
          : booking
      );

    default:
      return state;
  }
}

function comments(state: UserComment[] = [], action: Action): UserComment[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_COMMENTS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function favorites(state: Favorite[] = [], action: Action): Favorite[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_FAVORITES_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function ratings(state: Rating[] = [], action: Action): Rating[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_RATINGS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function walletDetail(state = [], action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_WALLET_LIST_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function walletLogs(state = [], action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_WALLET_LOG_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return true;
    case getSuccessActionType(FETCH_USER_REQUEST):
    case getFailureActionType(FETCH_USER_REQUEST):
      return false;

    case CHANGE_USER_STATUS_REQUEST:
      return true;
    case getSuccessActionType(CHANGE_USER_STATUS_REQUEST):
    case getFailureActionType(CHANGE_USER_STATUS_REQUEST):
      return false;

    case UPDATE_USER_REQUEST:
      return true;
    case getSuccessActionType(UPDATE_USER_REQUEST):
    case getFailureActionType(UPDATE_USER_REQUEST):
      return false;

    case FETCH_USER_BOOKINGS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_USER_BOOKINGS_REQUEST):
    case getFailureActionType(FETCH_USER_BOOKINGS_REQUEST):
      return false;

    case FETCH_USER_WALLET_LIST_REQUEST:
    case FETCH_USER_WALLET_LOG_REQUEST:
      return true;
    case getSuccessActionType(FETCH_USER_WALLET_LIST_REQUEST):
    case getFailureActionType(FETCH_USER_WALLET_LIST_REQUEST):
    case getSuccessActionType(FETCH_USER_WALLET_LOG_REQUEST):
    case getFailureActionType(FETCH_USER_WALLET_LOG_REQUEST):
      return false;

    default:
      return state;
  }
}

export const user = combineReducers({
  item,
  bookings,
  comments,
  favorites,
  ratings,
  walletDetail,
  walletLogs,
  isFetching,
});
